import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../base/base.component';

@Component({
  selector: 'app-map-bottom-toolbar',
  templateUrl: './map-bottom-toolbar.component.html',
  styleUrl: './map-bottom-toolbar.component.scss',
  standalone: false,
})
export class MapBottomToolbarComponent extends BaseComponent {
  constructor() {
    super();
  }
}
